export default __webpack_public_path__ + "static/media/akamai-icon.ab26d626.svg";